/*
 * This code is protected by intellectual property rights.
 * Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
 * © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
 */

import { Injectable } from '@angular/core'
import { BehaviorSubject } from 'rxjs'

@Injectable({
  providedIn: 'root',
})
export class FooterHeightService {
  private _height = new BehaviorSubject<number>(0)

  readonly height$ = this._height.asObservable()

  setHeight(height: number) {
    this._height.next(height)
  }
}
